import { PanelConfig } from '../types/config';

export const panelConfig: PanelConfig = {
  title: "DoCompare",
  brightnessOnHover: 90,
  imageUrl: 'pdf_to_txt_smallversion.png'
};